import dayjs from 'dayjs'
import { ICustomerContractDatesResponsePayload } from 'src/typings/types'

export function isDateWithinContract(day: dayjs.Dayjs, contract: ICustomerContractDatesResponsePayload): boolean {
  const from = dayjs(contract.from).startOf('day')
  const to = dayjs(contract.to).startOf('day')
  return !day.isBefore(from) && !day.isAfter(to)
}

export function shouldDisableDate(
  day: Date,
  contracts: ICustomerContractDatesResponsePayload[],
  dateRange: [Date | null, Date | null],
  loading: boolean,
  error: boolean
): boolean {
  if (loading || error) return true
  if (contracts.length === 0) return false

  const dayStart = dayjs(day).startOf('day')
  const [startDate, endDate] = dateRange

  if (startDate && !endDate) {
    const startDay = dayjs(startDate).startOf('day')
    const activeContract = contracts.find((contract) => isDateWithinContract(startDay, contract))
    if (activeContract) {
      const from = dayjs(activeContract.from).startOf('day')
      const to = dayjs(activeContract.to).startOf('day')
      return dayStart.isBefore(from) || dayStart.isAfter(to)
    }
  }

  return !contracts.some((contract) => isDateWithinContract(dayStart, contract))
}

export function validateSingleContract(
  value: (Date | undefined | null)[] | undefined,
  contracts: ICustomerContractDatesResponsePayload[]
): boolean {
  if (!value || !value[0] || !value[1]) return true
  if (contracts.length === 0) return true
  const startDay = dayjs(value[0]).startOf('day')
  const endDay = dayjs(value[1]).startOf('day')
  return contracts.some((contract) => {
    const from = dayjs(contract.from).startOf('day')
    const to = dayjs(contract.to).startOf('day')
    return !startDay.isBefore(from) && !endDay.isAfter(to)
  })
}
